import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";

function Navbar() {
    const [user, setUser] = useState(null);
    const navigate = useNavigate();

    useEffect(() => {
        const saved = localStorage.getItem("user");
        if (saved) setUser(JSON.parse(saved));
    }, []);

    const handleLogout = () => {
        console.log("LOGOUT CLICKED");   // 🔥 ADD THIS
        localStorage.removeItem("user");
        window.location.href = "/";       // full reload
    };
    useEffect(() => {
        const modal = document.getElementById("talkModal");
        const overlay = document.getElementById("customOverlay");

        modal.addEventListener("show.bs.modal", () => {
            overlay.style.display = "block";
        });

        modal.addEventListener("hidden.bs.modal", () => {
            overlay.style.display = "none";
        });
    }, []);


    return (
        <>
            <nav className="navbar navbar-expand-lg bg-white shadow-sm py-3 sticky-top">
                <div className="container">

                    {/* Logo */}
                    <Link to="/" className="navbar-brand d-flex align-items-center">
                        <img
                            src="/logo.png"
                            alt="Dial Nepal Logo"
                            style={{ width: "160px", marginRight: "49px" }}
                        />
                    </Link>

                    {/* Mobile Toggle */}
                    <button
                        className="navbar-toggler"
                        type="button"
                        data-bs-toggle="collapse"
                        data-bs-target="#mainNavbar"
                    >
                        <span className="navbar-toggler-icon"></span>
                    </button>

                    <div className="collapse navbar-collapse" id="mainNavbar">

                        {/* CENTER MENU */}
                        <ul className="navbar-nav mx-auto mb-2 mb-lg-0 pl-2">
                            <li className="nav-item px-2">
                                <Link className="nav-link fw-semibold text-dark" style={{ fontSize: "17px" }} to="/">Home</Link>
                            </li>

                            <li className="nav-item px-2">
                                <Link
                                    className="nav-link fw-semibold text-dark position-relative"
                                    style={{ fontSize: "17px" }}
                                    to="/#"
                                >
                                    Leads

                                    {/* 🔴 Red Dot (very close) */}
                                    <span
                                        style={{
                                            width: "7px",
                                            height: "7px",
                                            background: "red",
                                            borderRadius: "50%",
                                            position: "absolute",
                                            top: "5px",
                                            right: "1px"   // ← moved VERY close
                                        }}
                                    ></span>
                                </Link>
                            </li>



                            <li className="nav-item px-2">
                                <Link className="nav-link fw-semibold text-dark" style={{ fontSize: "17px" }} to="/#">Advertise</Link>
                            </li>

                            <li className="nav-item px-2">
                                <Link className="nav-link fw-semibold text-dark" style={{ fontSize: "17px" }} to="/#">Become An Agent</Link>
                            </li>
                        </ul>



                        {/* RIGHT SIDE BUTTONS */}
                        <div className="d-flex align-items-center gap-2 ms-lg-3 mt-3 mt-lg-0">

                            {/* 1️⃣ Free Listing Button */}
                            <Link to="/add-listing" className="fb btn  px-3 d-flex align-items-center" style={{
                                backgroundColor: "#0076d7",   // faint blue
                                color: "#ffffff",             // white text
                                border: "1px solid #6ea8fe"
                            }}>
                                <i className="bi bi-plus-lg me-1"></i>
                                Free Listing

                                {/* 🏷️ Small Tag Badge like JD business name */}
                                <span className="badge bg-warning text-dark ms-2" style={{ fontSize: "10px" }}>
                                    New
                                </span>
                            </Link>


                            <button
                                className="fb btn btn-success px-3"
                                data-bs-toggle="modal"
                                data-bs-target="#talkModal"
                            >
                                <i className="bi bi-telephone-fill me-1"></i>
                                Talk to Us
                            </button>
                            {/* Transparent Black Overlay (clickable) */}
                            <div
                                id="customOverlay"
                                style={{
                                    display: "none",
                                    position: "fixed",
                                    inset: 0,
                                    background: "rgba(0,0,0,0.3)",   // <-- Soft dark background
                                    zIndex: 1040,                    // Behind modal
                                    pointerEvents: "none"            // <-- does NOT block clicks
                                }}
                            ></div>

                            <div
                                className="modal fade"
                                id="talkModal"
                                tabIndex="-1"
                                data-bs-backdrop="false"
                                data-bs-keyboard="true"
                            >
                                <div className="modal-dialog modal-dialog-centered">
                                    <div
                                        className="modal-content p-0"
                                        style={{
                                            borderRadius: "18px",
                                            background: "#ffffff",
                                            boxShadow: "0 12px 35px rgba(0,0,0,0.25)",
                                            overflow: "hidden"
                                        }}
                                    >
                                        {/* ✨ TOP HEADER */}
                                        <div
                                            style={{
                                                background: "linear-gradient(135deg, #4C6EF5, #15AABF)",
                                                padding: "18px",
                                                textAlign: "center",
                                                color: "white"
                                            }}
                                        >
                                            <h5 className="fw-bold mb-0" style={{ letterSpacing: "0.3px" }}>
                                                Talk to Our Support Expert
                                            </h5>
                                        </div>

                                        {/* ✨ MODAL BODY */}
                                        <div className="p-4">

                                            {/* Agent Card */}
                                            <div
                                                className="d-flex align-items-center p-3 mb-4"
                                                style={{
                                                    background: "#f6f8ff",
                                                    borderRadius: "14px",
                                                    border: "1px solid #e0e6ff",
                                                    boxShadow: "0 4px 10px rgba(0,0,0,0.05)"
                                                }}
                                            >
                                                <img
                                                    src={`https://i.pravatar.cc/70?img=${Math.floor(Math.random() * 70)}`}
                                                    className="rounded-circle me-3"
                                                    alt="agent"
                                                    style={{
                                                        width: "60px",
                                                        height: "60px",
                                                        border: "2px solid #fff",
                                                        boxShadow: "0 2px 8px rgba(0,0,0,0.15)"
                                                    }}
                                                />

                                                <div>
                                                    <h6 className="fw-bold mb-1" style={{ fontSize: "17px" }}>
                                                        {["Aakash Sharma", "Ramesh Khatri", "Meera Singh", "Sujal Thapa"][
                                                            Math.floor(Math.random() * 4)
                                                        ]}
                                                    </h6>
                                                    <small className="text-muted">Available to assist you</small>
                                                </div>
                                            </div>

                                            {/* Input */}
                                            <label className="form-label fw-semibold">Your Mobile Number</label>
                                            <input
                                                type="tel"
                                                className="form-control mb-4"
                                                placeholder="98XXXXXXXX"
                                                maxLength="10"
                                                style={{
                                                    borderRadius: "12px",
                                                    height: "48px",
                                                    border: "1px solid #ccd4ff"
                                                }}
                                            />

                                            {/* Buttons */}
                                            <div className="d-flex justify-content-end gap-2">
                                                <button
                                                    className="btn btn-light px-4 py-2"
                                                    data-bs-dismiss="modal"
                                                    style={{
                                                        borderRadius: "10px",
                                                        border: "1px solid #ddd"
                                                    }}
                                                >
                                                    Cancel
                                                </button>

                                                <button
                                                    className="btn px-4 py-2"
                                                    style={{
                                                        borderRadius: "10px",
                                                        background: "linear-gradient(135deg, #38d9a9, #12b886)",
                                                        color: "white",
                                                        fontWeight: "600",
                                                        boxShadow: "0 5px 10px rgba(18,184,134,0.4)"
                                                    }}
                                                >
                                                    Request Call
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                            {/* BEFORE LOGIN → Show Login Button */}
                            {!user && (
                                <Link to="/login" className="btn btn-outline-primary px-3">
                                    <i className="bi bi-box-arrow-in-right me-1"></i>
                                    Login
                                </Link>
                            )}

                            {/* AFTER LOGIN */}
                            {user && (
                                <div className="dropdown">
                                    <button
                                        className="user-btn dropdown-toggle"
                                        data-bs-toggle="dropdown"
                                    >
                                        <i className="bi bi-person-circle me-2"></i>
                                        {user.fullname}
                                    </button>

                                    <ul className="dropdown-menu dropdown-menu-end shadow-sm">
                                        <li>
                                            <span className="dropdown-item-text small text-muted">
                                                Welcome
                                            </span>
                                        </li>

                                        <li>
                                            <span className="dropdown-item-text fw-semibold">
                                                {user.fullname}
                                            </span>
                                        </li>

                                        <li><hr className="dropdown-divider" /></li>

                                        <li>
                                            <Link
                                                className="dropdown-item"
                                                to={`/admin?userid=${user.personaluid}`}
                                            >
                                                <i className="bi bi-grid me-2"></i>
                                                Admin Panel
                                            </Link>
                                        </li>

                                        <li>
                                            <button
                                                className="dropdown-item text-danger"
                                                onClick={handleLogout}
                                            >
                                                <i className="bi bi-box-arrow-right me-2"></i>
                                                Logout
                                            </button>
                                        </li>
                                    </ul>
                                </div>
                            )}
                        </div>

                    </div>
                </div>
            </nav>

            {/* Internal CSS */}
            <style>{`
                .nav-text {
                    font-size: 15px;
                    font-weight: 500;
                    margin-right: 20px;
                }

                .nav-link:hover {
                    color: #0d6efd !important;
                }
            `}</style>
            <style>{`
                .dropdown-menu {
                    border-radius: 8px;
                }

                .dropdown-item:hover {
                    background: #f2f5ff;
                }

                .btn-light {
                    background: #fff;
                    border-radius: 6px;
                }
                    .user-btn {
                    background: transparent !important;
                    border: none !important;
                    outline: none !important;
                    box-shadow: none !important;
                    padding: 6px 12px;
                    display: flex;
                    align-items: center;
                    color: var(--bs-primary) !important;
                    font-weight: 500;
                }

                .user-btn i {
                    color: var(--bs-primary) !important;
                }

                /* Remove grey/blue hover & active effects */
                .user-btn:hover,
                .user-btn:focus,
                .user-btn:active,
                .user-btn.show {
                    background: transparent !important;
                    border: none !important;
                    outline: none !important;
                    box-shadow: none !important;
                    color: var(--bs-primary) !important;
                }
                    /* GLOBAL FONT SETTINGS */
body, .navbar, .nav-link, .dropdown-menu, .btn {
    font-family: "Poppins", sans-serif !important;
    font-size: 14px !important;
    font-weight: 400 !important;
    color: #000 !important;
}
.fb{

color: #fff !important; }

/* NAV ITEMS SMALL + RIGHT ALIGN */
#mainNavbar .navbar-nav {
    margin-left: auto !important;  /* ← moves all 4 nav items to RIGHT */
    margin-right: 0 !important;
}

/* Reduce gap between items slightly */
#mainNavbar .nav-item {
    padding-left: 6px !important;   /* reduced from px-2 */
    padding-right: 6px !important;
}

/* BUTTONS SMALL LIKE JustDial */
.navbar .btn {
    padding: 4px 10px !important;
    font-size: 13px !important;
    border-radius: 6px !important;
}

/* Free Listing button small badge */
.navbar .badge {
    font-size: 8px !important;
    padding: 2px 4px !important;
}

/* Logo gap reduce */
.navbar-brand img {
    margin-right: 20px !important;
}

/* Talk to us icon spacing reduce */
.btn i {
    margin-right: 4px !important;
}


            `}</style>

        </>
    );
}

export default Navbar;
